// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"9e683386","16":"3479977e","300":"e7f59b02","453":"127be8e2","597":"9c212077","652":"f81438ed","890":"10a661ae","975":"8a6d3175"}[chunkId] + ".chunk.js";
};